<template>
    <div>
        <b-row>
            <b-col>
                <p class="mb-1 ml-1 text-muted text-uppercase">
                    <small>
                        <i class="icon-speech"></i>
                        {{ $t('form.label.tags') }}
                    </small>
                </p>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <div v-if="tags.length">
                    <b-badge
                        v-for="tag in tags"
                        :key="tag.id"
                        variant="light"
                        class="text-muted"
                        pill
                    >
                        {{ tag.title }}
                    </b-badge>
                </div>
                <span class="text-muted ml-2" v-else>
                    {{ $t('notification.noTagFoundForThisGoal') }}
                </span>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <button
                    id="btn-target-tags"
                    @click="openModal()"
                    type="button"
                    class="float-right btn btn-ghost-primary btn-pill btn-sm"
                    :disabled="!isAllowedToEdit"
                >
                    {{ $t('form.button.edit') }}
                </button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: 'Tag',
    props: ['data', 'target', 'isAllowedToEdit'],
    methods: {
        openModal() {
            this.$router.push({
                path: `/v2/target/targets/view/${this.target.id}/tags`,
            })
        },
    },
    computed: {
        tags: function () {
            return this.data
        },
    },
}
</script>
